// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-info-panel[data-v-6a70a55a] {\n\tmax-width: 960px;\n}\n.sidebar[data-v-6a70a55a] {\n\tposition: -webkit-sticky;\n\tposition: sticky;\n\ttop: 5rem;\n\t/* margin-top: 49px; */\n}\n", ""]);
// Exports
module.exports = exports;
